import React from 'react';
import InputField from 'Components/InputField/InputField';

const PasswordField = () => {
  return (
    <InputField placeholder='Password' />
  )
}

export default PasswordField;